// 引入语言文件
import enLocale from '../locales/chinaKeys/en.json'
import jaJPLocale from '../locales/chinaKeys/ja_JP.json'
import viVNLocale from '../locales/chinaKeys/vi_VN.json'
import zhHansLocale from '../locales/chinaKeys/zh-Hans.json'
import zhHantLocale from '../locales/chinaKeys/zh-TW.json'

import enEnKeyLocale from '../locales/enKeys/en.json'
import jaJpEnKeyLocale from '../locales/enKeys/ja_JP.json'
import viVNEnKeyLocale from '../locales/enKeys/vi_VN.json'
import zhHansEnKeyLocale from '../locales/enKeys/zh-CN.json'
import zhTwEnKeyLocale from '../locales/enKeys/zh-TW.json'
import sassmallEnLocale from '../locales/sassmall/en.json'
import sassmallJaJPLocale from '../locales/sassmall/ja_JP.json'
import sassmallViVNLocale from '../locales/sassmall/vi_VN.json'
import sassmallZhHansLocale from '../locales/sassmall/zh-CN.json'
import sassmallZhHantLocale from '../locales/sassmall/zh-TW.json'

import { cloneDeep, get, merge } from 'lodash-es'
import { createI18n } from 'vue-i18n'

type LocaleMessageMap = Record<string, any>

interface LocaleSourceModules {
  enLocale: any
  jaJPLocale: any
  viVNLocale: any
  zhHansLocale: any
  zhHantLocale: any
  zhHansEnKeyLocale: any
  enEnKeyLocale: any
  viVNEnKeyLocale: any
  zhTwEnKeyLocale: any
  jaJpEnKeyLocale: any
  sassmallEnLocale: any
  sassmallJaJPLocale: any
  sassmallViVNLocale: any
  sassmallZhHansLocale: any
  sassmallZhHantLocale: any
}

const localeSourceModules: LocaleSourceModules = {
  enLocale,
  jaJPLocale,
  viVNLocale,
  zhHansLocale,
  zhHantLocale,
  zhHansEnKeyLocale,
  enEnKeyLocale,
  viVNEnKeyLocale,
  zhTwEnKeyLocale,
  jaJpEnKeyLocale,
  sassmallEnLocale,
  sassmallJaJPLocale,
  sassmallViVNLocale,
  sassmallZhHansLocale,
  sassmallZhHantLocale,
}

function buildMessages(sourceModules: LocaleSourceModules): LocaleMessageMap {
  const newHantJson: any = merge(
    cloneDeep(sourceModules.zhHansLocale),
    cloneDeep(sourceModules.zhHantLocale),
  )

  return {
    'zh-CN': merge(cloneDeep(sourceModules.zhHansLocale), cloneDeep(sourceModules.zhHansEnKeyLocale), { sassmall: cloneDeep(sourceModules.sassmallZhHansLocale) }),
    'zh-Hans': merge(cloneDeep(sourceModules.zhHansLocale), cloneDeep(sourceModules.zhHansEnKeyLocale), { sassmall: cloneDeep(sourceModules.sassmallZhHansLocale) }),
    'zh-Hant': merge(cloneDeep(newHantJson), cloneDeep(sourceModules.zhTwEnKeyLocale), { sassmall: cloneDeep(sourceModules.sassmallZhHantLocale) }),
    'zh-TW': merge(cloneDeep(newHantJson), cloneDeep(sourceModules.zhTwEnKeyLocale), { sassmall: cloneDeep(sourceModules.sassmallZhHantLocale) }),
    'en': merge(cloneDeep(sourceModules.enLocale), cloneDeep(sourceModules.enEnKeyLocale), { sassmall: cloneDeep(sourceModules.sassmallEnLocale) }),
    'ja_JP': merge(cloneDeep(sourceModules.jaJPLocale), cloneDeep(sourceModules.jaJpEnKeyLocale), { sassmall: cloneDeep(sourceModules.sassmallJaJPLocale) }),
    'ja': merge(cloneDeep(sourceModules.jaJPLocale), cloneDeep(sourceModules.jaJpEnKeyLocale), { sassmall: cloneDeep(sourceModules.sassmallJaJPLocale) }),
    'vi_VN': merge(cloneDeep(sourceModules.viVNLocale), cloneDeep(sourceModules.viVNEnKeyLocale), { sassmall: cloneDeep(sourceModules.sassmallViVNLocale) }),
    'vi': merge(cloneDeep(sourceModules.viVNLocale), cloneDeep(sourceModules.viVNEnKeyLocale), { sassmall: cloneDeep(sourceModules.sassmallViVNLocale) }),
  }
}

// function tranStrToAllKeys(obj: any): void {
//   lodash.forEach(obj, function (value: any, key: any) {
//     if (lodash.isObject(value)) {
//       tranStrToAllKeys(value);
//     } else {
//       obj[key] = zhTranFn(obj[key], "t");
//     }
//   });
// }
// tranStrToAllKeys(newHantJson);

let messages: LocaleMessageMap = buildMessages(localeSourceModules)

const DEFAULT_LOCALE = 'zh-Hant'
const USER_CENTER_LOCALE_KEY = 'current_user_center_locale'
const NOW_LOCALE_KEY = 'now-locale'
const NUXT_LOCALE_KEY = 'i18n_current_locale'

function getBrowserStorage(): Storage | null {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage
  }
  if (typeof localStorage !== 'undefined') {
    return localStorage
  }
  return null
}

function getStoredLocale(key: string): string | null {
  return getBrowserStorage()?.getItem(key) || null
}

function setStoredLocale(key: string, value: string): void {
  getBrowserStorage()?.setItem(key, value)
}

function normalizeNuxtLocale(locale: string): string {
  const localeMap: Record<string, string> = {
    'zh-Hans': 'zh-CN',
    'zh-Hant': 'zh-TW',
    'zh': 'zh-CN',
    'tw': 'zh-TW',
    'vi': 'vi_VN',
    'ja': 'ja_JP',
  }
  return localeMap[locale] || locale
}

function setLocaleCookie(key: string, value: string): void {
  if (typeof document === 'undefined') {
    return
  }
  document.cookie = `${key}=${encodeURIComponent(value)}; path=/; max-age=31536000; SameSite=Lax`
}

function resolveInitialLocale(): string {
  if (typeof window === 'undefined') {
    return DEFAULT_LOCALE
  }

  const currentUserCenterLocale = getStoredLocale(USER_CENTER_LOCALE_KEY)
  if (currentUserCenterLocale) {
    setStoredLocale(NOW_LOCALE_KEY, currentUserCenterLocale)
    return currentUserCenterLocale
  }

  const currentLocale = getStoredLocale(NOW_LOCALE_KEY)
  if (currentLocale) {
    return currentLocale
  }

  return DEFAULT_LOCALE
}

let nowLocale: any = resolveInitialLocale()
// 创建 i18n 实例
const i18n = createI18n({
  locale: nowLocale as any, // 设置默认语言
  fallbackLocale: DEFAULT_LOCALE as any, // 如果当前语言没有对应的翻译，则回退到默认语言
  messages: messages as any, // 设置语言信息
})

function replaceLocaleMessages(nextMessages: LocaleMessageMap): void {
  messages = nextMessages
  Object.keys(nextMessages).forEach((locale) => {
    i18n.global.setLocaleMessage(locale, nextMessages[locale])
  })
}

if (import.meta.hot) {
  import.meta.hot.accept([
    '../locales/chinaKeys/en.json',
    '../locales/chinaKeys/ja_JP.json',
    '../locales/chinaKeys/vi_VN.json',
    '../locales/chinaKeys/zh-Hans.json',
    '../locales/chinaKeys/zh-TW.json',
    '../locales/enKeys/zh-CN.json',
    '../locales/enKeys/en.json',
    '../locales/enKeys/vi_VN.json',
    '../locales/enKeys/zh-TW.json',
    '../locales/enKeys/ja_JP.json',
    '../locales/sassmall/en.json',
    '../locales/sassmall/ja_JP.json',
    '../locales/sassmall/vi_VN.json',
    '../locales/sassmall/zh-CN.json',
    '../locales/sassmall/zh-TW.json',
  ], (modules) => {
    if (!modules || modules.length < 15) {
      return
    }

    const [
      nextEnLocale,
      nextJaJPLocale,
      nextViVNLocale,
      nextZhHansLocale,
      nextZhHantLocale,
      nextZhHansEnKeyLocale,
      nextEnEnKeyLocale,
      nextViVNEnKeyLocale,
      nextZhTwEnKeyLocale,
      nextJaJpEnKeyLocale,
      nextSassmallEnLocale,
      nextSassmallJaJPLocale,
      nextSassmallViVNLocale,
      nextSassmallZhHansLocale,
      nextSassmallZhHantLocale,
    ] = modules.map((item: any) => item?.default ?? item)

    replaceLocaleMessages(buildMessages({
      enLocale: nextEnLocale,
      jaJPLocale: nextJaJPLocale,
      viVNLocale: nextViVNLocale,
      zhHansLocale: nextZhHansLocale,
      zhHantLocale: nextZhHantLocale,
      zhHansEnKeyLocale: nextZhHansEnKeyLocale,
      enEnKeyLocale: nextEnEnKeyLocale,
      viVNEnKeyLocale: nextViVNEnKeyLocale,
      zhTwEnKeyLocale: nextZhTwEnKeyLocale,
      jaJpEnKeyLocale: nextJaJpEnKeyLocale,
      sassmallEnLocale: nextSassmallEnLocale,
      sassmallJaJPLocale: nextSassmallJaJPLocale,
      sassmallViVNLocale: nextSassmallViVNLocale,
      sassmallZhHansLocale: nextSassmallZhHansLocale,
      sassmallZhHantLocale: nextSassmallZhHantLocale,
    }))
  })
}

export function $t(name: string, data?: any): string {
  const currentLocale: any = get(i18n, 'global.locale.value') || getStoredLocale('now-locale') || DEFAULT_LOCALE
  if (get(i18n, 'global.t')) {
    return i18n.global.t(name, data)
  }
  let setText: string
    = (messages[currentLocale] && get(messages[currentLocale], name))
      || name
  if (setText && data && Object.keys(data) && Object.keys(data).length > 0) {
    Object.keys(data).forEach((k) => {
      if (typeof data[k] != 'undefined') {
        setText = setText.replace(`{${k}}`, data[k])
      }
    })
  }
  return setText
}

export function isLongLocale(locale: string): boolean {
  const LongLocaleMap: Record<string, boolean> = {
    en: true,
    ja_JP: true,
    ja: true,
    vi_VN: true,
    vi: true,
  }
  return !!LongLocaleMap[locale]
}

export function isChinaLocale(locale: string): boolean {
  const chinaLocaleMap: Record<string, boolean> = {
    'zh-CN': true,
    'zh-Hans': true,
    'zh-Hant': true,
    'zh-TW': true,
  }
  return !!chinaLocaleMap[locale]
}
export function isTwLocale(locale?: string): boolean {
  const chinaLocaleMap: Record<string, boolean> = {

    'zh-Hant': true,
    'zh-TW': true,
  }

  return !!chinaLocaleMap[locale || getCurrentLocale()]
}
export function getCurrentLocale() {
  return get(i18n, 'global.locale.value') || getStoredLocale('now-locale') || DEFAULT_LOCALE
}
export function getCurrentLocaleTransferCode() {
  const code = getCurrentLocale()
  const codeMap: Record<string, string> = {
    vi_VN: 'vi',
    ja_JP: 'ja',
  }
  return codeMap[code] ? codeMap[code] : code
}
export function isToTransfer(locale?: string): boolean {
  if (!locale) {
    locale = get(i18n, 'global.locale.value') || getStoredLocale('now-locale') || DEFAULT_LOCALE
  }

  return !isChinaLocale(String(locale || ''))
}

export function toggleLocale(locale: string): boolean {
  const nuxtLocale = normalizeNuxtLocale(locale)
  setStoredLocale(USER_CENTER_LOCALE_KEY, locale)
  setStoredLocale(NOW_LOCALE_KEY, locale)
  setStoredLocale(NUXT_LOCALE_KEY, nuxtLocale)
  setLocaleCookie(NUXT_LOCALE_KEY, nuxtLocale)
  nowLocale = locale
  if (typeof window !== 'undefined') {
    window.location.reload()
  }
  return true
}

export function getLocaleText(locale?: string): string {
  if (!locale) {
    locale = getStoredLocale('now-locale') || DEFAULT_LOCALE
  }
  const shotTexts: Record<string, string> = {
    'zh-Hans': 'zh',
    'zh-CN': 'zh',
    'zh-Hant': 'zh-tw',
    'zh-TW': 'zh-tw',
    'en': 'en',
    'ja_JP': 'ja',
    'ja': 'ja',
    'vi': 'vi',
    'vi_VN': 'vi',
  }
  return shotTexts[locale] || ''
}

export default i18n
